import * as React from 'react'
import { MoonLoader } from 'react-spinners'

interface IPreloaderCircleProps {
  loading: boolean
}

const PreloaderCircle = (props: IPreloaderCircleProps) => {
  const colorBlue = '#405264'
  return <MoonLoader sizeUnit={'px'} size={27} color={colorBlue} loading={props.loading} />
}

export default PreloaderCircle



// WEBPACK FOOTER //
// ./src/components/ui/PreloaderCircle.tsx